<template>
    <div class="month-navigator" role="group" :aria-label="label">
        <button type="button" aria-label="Предыдущий месяц" title="Предыдущий месяц" @click="shift(-1)"><i class="fas fa-chevron-left" aria-hidden="true"></i></button>
        <input type="month" :value="value" min="0001-01" max="9999-12" :aria-label="label" @change="select($event.target.value)">
        <button type="button" aria-label="Следующий месяц" title="Следующий месяц" @click="shift(1)"><i class="fas fa-chevron-right" aria-hidden="true"></i></button>
    </div>
</template>

<script>
export default {
    name: 'MonthNavigator',
    props: {value: String, label: {type: String, default: 'Месяц табелей'}},
    methods: {
        select(value) { if (/^(?!0000)\d{4}-(0[1-9]|1[0-2])$/.test(value)) this.$emit('input', value); },
        shift(delta) {
            if (!this.value) return;
            const [year, month] = this.value.split('-').map(Number);
            const index = year * 12 + month - 1 + delta;
            this.select(String(Math.floor(index / 12)).padStart(4, '0') + '-' + String(index % 12 + 1).padStart(2, '0'));
        }
    }
};
</script>

<style scoped>
.month-navigator { display: inline-flex; align-items: stretch; flex: 0 0 auto; max-width: 100%; }
.month-navigator input, .month-navigator button { min-height: 32px; border: 1px solid #bdcddd; background: #fff; color: #34495d; font: inherit; }
.month-navigator input { width: 144px; min-width: 0; border-radius: 0; padding: 4px 6px; }
.month-navigator button { width: 32px; padding: 4px; }
.month-navigator button:first-child { border-radius: 5px 0 0 5px; border-right: 0; }
.month-navigator button:last-child { border-radius: 0 5px 5px 0; border-left: 0; }
.month-navigator button:hover { background: #edf4fb; }
.month-navigator :focus-visible { outline: 2px solid #4484bf; outline-offset: 1px; z-index: 1; }
</style>
